import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --dark-bg: #121212;
    --dark-surface: #1e1e1e;
    --dark-surface-2: #2d2d2d;
    --primary: #bb86fc;
    --primary-variant: #3700b3;
    --secondary: #03dac6;
    --error: #cf6679;
    /* Escalera de tinta sobre canvas oscuro. La misma alpha rinde mas contraste
       sobre negro que sobre blanco, por eso los peldanos son mas bajos que los
       de Material: 0.6 y 0.38 sonaban mas fuerte de lo que debian. */
    --text-primary: rgba(255, 255, 255, 0.92);
    --text-secondary: rgba(255, 255, 255, 0.56);
    --text-tertiary: rgba(255, 255, 255, 0.46);
    --border: rgba(255, 255, 255, 0.10);
    --border-strong: rgba(255, 255, 255, 0.18);
    --hover: rgba(255, 255, 255, 0.09);
    --pressed: rgba(255, 255, 255, 0.14);
    --text-disabled: rgba(255, 255, 255, 0.38);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background-color: var(--dark-bg);
    color: var(--text-primary);
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    touch-action: manipulation;
  }

  a {
    color: var(--primary);
    text-decoration: none;
    transition: color 0.2s ease;

    /* El cian era un segundo acento decorativo: un solo acento por sistema. */
    &:hover {
      color: var(--text-primary);
    }
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  :focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--dark-bg);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--dark-surface-2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--primary);
  }
`;

export default GlobalStyles;
